// extracted by mini-css-extract-plugin
module.exports = {"container":"pokemonCards_container__1HS34"};